$(document).ready(function(){  
$(".js-header-cart").click(function(){
  $("html").addClass("scroll-fixed");
});
$(".drawer__header").click(function(){
  $("html").removeClass("scroll-fixed");
});
// $(".js-btn-quickview").click(function(e){
//   e.preventDefault();
//   console.log("Adasdasdasd");
//   $("html").addClass("scroll-fixed");
// });
$(".quickview__content .quickview__btn-close").click(function(e){
  e.preventDefault();
  console.log("Adasdasdasd");
  $("html").removeClass("scroll-fixed");
});
  
  
    $(".menu_drawer_close_icon").click(function(){
        $(".menu-drawer-container").removeClass("menu-opening");
        $("body").removeClass("menu_drawer_fixed");
        $(".menu-drawer-container").removeAttr("open","open");
    });
  
  
    $(".product_need_btn").click(function(){
       $(".need_poppup_block").addClass("product_drawer_open");
       $("body").addClass("drawer_open");
       $("html").addClass("drawer-open");
    });
  
    $(".need_close_btn").click(function(){
       $(".need_poppup_block").removeClass("product_drawer_open");
       $("body").removeClass("drawer_open");
       $("html").removeClass("drawer-open");
    });
  
  
    $(".variants_info .btn").click(function(){
       $("html").addClass("drawer-open");
    });
  
    $(".modal-header .btn-close").click(function(){
       $("html").removeClass("drawer-open");
    });

   $(".perfect_product_list").slick({
       slidesToShow: 2,
       infinite: false,
       slidesToScroll: 2,
       autoplay: false,
       autoplaySpeed: 2500,
       dots: false,
      arrows: false,
       responsive:[
         {
            breakpoint: 5000,
            settings: 'unslick'
          },
         {
            breakpoint: 576,
            settings: {
               infinite: true,
               slidesToShow: 1,   
               centerMode: true,
               centerPadding:'91px',
            }
          }
       ]
    });
  
    $(".hero_banner_main").slick({
     slidesToShow: 1,
     infinite: true,
     slidesToScroll: 1,
     autoplay: false,
     autoplaySpeed: 2000,
     dots: false,
     prevArrow: '<button class="slick-prev slick-arrow"><svg width="30" height="50" viewBox="0 0 30 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-9.33768e-07 25.0001C-9.59176e-07 24.4189 0.244371 23.837 0.732493 23.3933L25.7324 0.66605C26.7092 -0.222017 28.2911 -0.222017 29.2673 0.66605C30.2436 1.55412 30.2442 2.99218 29.2673 3.87968L6.03497 25.0001L29.2673 46.1205C30.2442 47.0086 30.2442 48.4467 29.2673 49.3342C28.2905 50.2217 26.7086 50.2222 25.7324 49.3342L0.732493 26.6069C0.244371 26.1632 -9.08361e-07 25.5814 -9.33768e-07 25.0001Z" fill="currentColor"/></svg></button>',
     nextArrow: '<button class="slick-next slick-arrow"><svg width="30" height="50" viewBox="0 0 30 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 25.0001C30 24.4189 29.7556 23.837 29.2675 23.3933L4.26763 0.66605C3.29076 -0.222017 1.7089 -0.222017 0.732653 0.66605C-0.243593 1.55412 -0.244218 2.99218 0.732652 3.87968L23.965 25.0001L0.732651 46.1205C-0.24422 47.0086 -0.24422 48.4467 0.73265 49.3342C1.70952 50.2217 3.29139 50.2222 4.26763 49.3342L29.2675 26.6069C29.7556 26.1632 30 25.5814 30 25.0001Z" fill="currentColor"/></svg></button>',           
     arrows: true,
      responsive: [
          {
            breakpoint: 768,
            settings: {
               slidesToShow: 1,   
               dots: true,
               arrows: false,
            }
          }
        ]
    });
  
    $(".universe_product_slider").slick({
       slidesToShow: 4,
       infinite: true,
       slidesToScroll: 1,
       autoplay: false,
       autoplaySpeed: 2000,
       dots: false,
       prevArrow: '<button class="slick-prev slick-arrow"><svg width="30" height="50" viewBox="0 0 30 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-9.33768e-07 25.0001C-9.59176e-07 24.4189 0.244371 23.837 0.732493 23.3933L25.7324 0.66605C26.7092 -0.222017 28.2911 -0.222017 29.2673 0.66605C30.2436 1.55412 30.2442 2.99218 29.2673 3.87968L6.03497 25.0001L29.2673 46.1205C30.2442 47.0086 30.2442 48.4467 29.2673 49.3342C28.2905 50.2217 26.7086 50.2222 25.7324 49.3342L0.732493 26.6069C0.244371 26.1632 -9.08361e-07 25.5814 -9.33768e-07 25.0001Z" fill="currentColor"/></svg></button>',
       nextArrow: '<button class="slick-next slick-arrow"><svg width="30" height="50" viewBox="0 0 30 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 25.0001C30 24.4189 29.7556 23.837 29.2675 23.3933L4.26763 0.66605C3.29076 -0.222017 1.7089 -0.222017 0.732653 0.66605C-0.243593 1.55412 -0.244218 2.99218 0.732652 3.87968L23.965 25.0001L0.732651 46.1205C-0.24422 47.0086 -0.24422 48.4467 0.73265 49.3342C1.70952 50.2217 3.29139 50.2222 4.26763 49.3342L29.2675 26.6069C29.7556 26.1632 30 25.5814 30 25.0001Z" fill="currentColor"/></svg></button>',           
       arrows: false,
       responsive: [
          {
            breakpoint: 1400,
            settings: {
               slidesToShow: 3,
            }
          },
          {
            breakpoint: 768,
            settings: {
               slidesToShow: 2,
            }
          },
          {
            breakpoint: 576,
            settings: {
               slidesToShow: 1,   
               centerMode: true,
              centerPadding:'89px',
            }
          },
          {
            breakpoint: 370,
            settings: {
               slidesToShow: 1,   
               centerMode: true,
              centerPadding:'50px',
            }
          }
        ]
    });  

  
    var $slider = $('.best_slide');
    var $progressBar = $('.best_info_progress');
    var $progressBarLabel = $( '.best_info_slider_label' );
  // logic
  toTop.on('click', function() {
    $('html, body').animate({
      scrollTop: $('html, body').offset().top,
    });
  });

  
    // $slider.slick({
    //    slidesToShow: 3,
    //    infinite: false,
    //    slidesToScroll: 1,
    //    autoplay: false,
    //   cssEase: 'linear',
    //   easing:'linear',
    //    // autoplaySpeed: 2000,
    //    dots: false,
    //    prevArrow: '<button class="slick-prev slick-arrow"><svg width="30" height="50" viewBox="0 0 30 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-9.33768e-07 25.0001C-9.59176e-07 24.4189 0.244371 23.837 0.732493 23.3933L25.7324 0.66605C26.7092 -0.222017 28.2911 -0.222017 29.2673 0.66605C30.2436 1.55412 30.2442 2.99218 29.2673 3.87968L6.03497 25.0001L29.2673 46.1205C30.2442 47.0086 30.2442 48.4467 29.2673 49.3342C28.2905 50.2217 26.7086 50.2222 25.7324 49.3342L0.732493 26.6069C0.244371 26.1632 -9.08361e-07 25.5814 -9.33768e-07 25.0001Z" fill="currentColor"/></svg></button>',
    //    nextArrow: '<button class="slick-next slick-arrow"><svg width="30" height="50" viewBox="0 0 30 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 25.0001C30 24.4189 29.7556 23.837 29.2675 23.3933L4.26763 0.66605C3.29076 -0.222017 1.7089 -0.222017 0.732653 0.66605C-0.243593 1.55412 -0.244218 2.99218 0.732652 3.87968L23.965 25.0001L0.732651 46.1205C-0.24422 47.0086 -0.24422 48.4467 0.73265 49.3342C1.70952 50.2217 3.29139 50.2222 4.26763 49.3342L29.2675 26.6069C29.7556 26.1632 30 25.5814 30 25.0001Z" fill="currentColor"/></svg></button>',           
    //    arrows: false,
    //    centerMode: false,
    //    centerPadding:'61px',
    //    responsive: [
    //       {
    //         breakpoint: 1400,
    //         settings: {
    //            centerPadding:'130px',
    //         }
    //       },
    //       {
    //         breakpoint: 1199,
    //         settings: {
    //            slidesToShow: 2,
    //         }
    //       },
    //       {
    //         breakpoint: 991,
    //         settings: {
    //            slidesToShow: 2,              
    //           centerPadding:'80px',
    //         }
    //       },
    //       {
    //         breakpoint: 575,
    //         settings: {
    //            slidesToShow: 1,              
    //           centerPadding:'80px',
    //         }
    //       }
    //     ]
    // });  
});

$(document).ready(function() {
    if ($(window).width() <  768) {
         $('.footer_link ul').hide();
         $('.footer_link .footer_title').unbind().click(function() {
             $('.footer_link .footer_title').not($(this)).removeClass('active');
             $('.footer_link ul').not($(this).siblings('.footer_link ul')).slideUp();
             $(this).siblings('.footer_link ul').slideToggle();
             $(this).toggleClass('active');
        });
    }
});
 $(window).resize(function() {
    if ($(window).width() <  768) {
         $('.footer_link ul').hide();
         $('.footer_link .footer_title').unbind().click(function() {
             $('.footer_link .footer_title').not($(this)).removeClass('active');
             $('.footer_link ul').not($(this).siblings('.footer_link ul')).slideUp();
             $(this).siblings('.footer_link ul').slideToggle();
             $(this).toggleClass('active');
        });
    }
    else {
         $('.footer_link ul').show();
    }
});


$(document).ready(function() {

    $(".collection_grid_view").click(function(){
        
        $(".collection_view_btn").removeClass("active");
        $(this).addClass("active");
        $(".collection_product_item").removeClass("list_view");      

    });
    $(".collection_list_view").click(function(){
        
        $(".collection_view_btn").removeClass("active");
        $(this).addClass("active");
        $(".collection_product_item").addClass("list_view");      

    });
    });


$(document).ready(function() {
  var isSafariMac = /^((?!chrome|android|crios|fxios).)*\bApple\b.*Safari\b.*Macintosh\b/.test(navigator.userAgent);

  if (isSafariMac) {
    $('html').addClass('safari-mac');
  }

  $(".header .header__search").click(function(){
  $("body").addClass("search-open");
});

$(".header .search-modal__close-button").click(function(){
  $("body").removeClass("search-open");
});
  
});



if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
jQuery('html').addClass('safari-mac');
}
if (navigator.userAgent.indexOf('Mac OS X') != -1) {
jQuery("html").addClass("safari-mac");
} else {
jQuery("html").addClass("pc");
}
       

$(window).scroll(function(){
  if ($(window).scrollTop() >= 3) {
      $('#shopify-section-header').addClass('fixed-header');
      $('body').addClass('fix-header');
  }
  else {
      $('#shopify-section-header').removeClass('fixed-header');
      $('body').removeClass('fix-header');
  }
});



/* cart drawer size and color */

// $(document).ready(function() {
//   // Retrieve the variation data and update the format
//   setTimeout(function(){
//     var variationData = $('.ajaxcart__product-meta').text();
//     var formattedData = transformVariationData(variationData);
  
//     // Update the content of the span element
//     $('.ajaxcart__product-meta').html(formattedData);
//   }, 2000);
// });

// Function to transform the variation data format
// function transformVariationData(variationData) {
//   // Split the variation data into color and size
//   var parts = variationData.split(' / ');
//   var color = parts[0];
//   var size = parts[1];

//   // Create the formatted string with line breaks
//   var formattedString = "<div class='size'>" +'Size: ' + size + "</div>" + "<div class='color'>" + 'Color: ' + color + "</div>";
//   return formattedString;
// }

//  $(document).ready(function() {
// // MAC/iphone js
// if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
// jQuery('html').addClass('mac');
//    var body_height = screen.height;
//       var desiredHeight = body_height - 178;
//       $("#menu-drawer").css("height", desiredHeight + "px");
// }
// if (navigator.userAgent.indexOf('Mac OS X') != -1) {
// jQuery("html").addClass("mac");
//    var body_height = screen.height;
//       var desiredHeight = body_height - 178;
//       $("#menu-drawer").css("height", desiredHeight + "px");
// } else {
// jQuery("html").addClass("pc");
//    var body_height = screen.height;
//       var desiredHeight = body_height;
//       $("#menu-drawer").css("height", desiredHeight + "px");
// }
//   });


// function isAndroidDevice() {
//     const userAgent = navigator.userAgent.toLowerCase();
//     return /android/.test(userAgent);
// }

// var menuDrawer = document.getElementById("menu-drawer");

// if (isAndroidDevice()) {
//     // Code that should run only on Android devices
//     $(document).ready(function() {
//       $("#menu-drawer").addClass("android");        
//       $(".header__icon--menu .header_dropdown svg").click(function(){
//          $('body').removeClass('fix-header');
//         $('#shopify-section-header').removeClass('fixed-header');
//       });
      
//     });

// function handleScroll() {
//     var body_height_x = screen.height;
//     var desiredHeight_x = body_height_x - 75;

//     $("#menu-drawer").css("height", desiredHeight_x + "px");
// }
// $(window).on("scroll load", handleScroll);

  
// } else {
//     // Code for other platforms (non-Android)
//     $(document).ready(function() {
//       $("#menu-drawer").removeClass("android");        
//       $(".header__icon--menu .header_dropdown svg").click(function(){
//          $('body').addClass('fix-header');
//         $('#shopify-section-header').addClass('fixed-header');
//       });
//     });
// }



